import React from 'react';
import './QuizStats.css';

const QuizStats = ({ totalQuestions, answeredQuestions, incorrectQuestions, loading }) => {
  const unansweredCount = totalQuestions - answeredQuestions.length;
  const correctCount = answeredQuestions.length - incorrectQuestions.length;
  
  // Debug logging
  console.log('QuizStats props:', { 
    totalQuestions, 
    answeredQuestions: answeredQuestions.length, 
    incorrectQuestions: incorrectQuestions.length,
    unansweredCount,
    correctCount,
    loading
  });
  
  const getPercentage = (count) => {
    if (totalQuestions === 0) return 0;
    return Math.round((count / totalQuestions) * 100);
  };

  if (loading) {
    return (
      <div className="quiz-stats loading">
        <h4>統計データを読み込み中...</h4>
      </div>
    );
  }

  return (
    <div className="quiz-stats">
      <h4>問題統計 (全{totalQuestions}問)</h4>
      
      <div className="unified-bar">
        <div className="bar-track">
          <div 
            className="bar-segment unanswered" 
            style={{ width: `${getPercentage(unansweredCount)}%` }}
          ></div>
          <div 
            className="bar-segment correct" 
            style={{ width: `${getPercentage(correctCount)}%` }}
          ></div>
          <div 
            className="bar-segment incorrect" 
            style={{ width: `${getPercentage(incorrectQuestions.length)}%` }}
          ></div>
        </div>
        
        <div className="bar-legend">
          <div className="legend-item">
            <div className="legend-color unanswered"></div>
            <span>未出題 {unansweredCount}問 ({getPercentage(unansweredCount)}%)</span>
          </div>
          <div className="legend-item">
            <div className="legend-color correct"></div>
            <span>正解済み {correctCount}問 ({getPercentage(correctCount)}%)</span>
          </div>
          <div className="legend-item">
            <div className="legend-color incorrect"></div>
            <span>不正解 {incorrectQuestions.length}問 ({getPercentage(incorrectQuestions.length)}%)</span>
          </div>
        </div>
      </div>
      
      {answeredQuestions.length > 0 && (
        <div className="stats-summary">
          正答率: {Math.round((correctCount / answeredQuestions.length) * 100)}%
        </div>
      )}
    </div>
  );
};

export default QuizStats;